export default __webpack_public_path__ + "static/media/icon-work.5e623aec.svg";